<template>
    <main>
        <Contact></Contact>
    </main>
</template>

<script>
import Contact from './Home/Contact.vue';
export default {
    name: "main-contact",
    data() {
        return {};
    },
    components: { Contact }
}
</script>